<template>
  <el-dialog
    :title="$t(title)"
    :modal-append-to-body="false"
    custom-class="disposition-alarm-multi"
    :visible="visible"
    @close="cancel"
    top="10vh"
  >
    <el-scrollbar wrap-style="height: 60vh;" element-loading-background="rgba(0, 0, 0, 0.8)">
      <div style="padding: 20px">
        <m-table
          ref="table"
          :i18nPath="i18nPath"
          :tableData="tableData"
          :tableColumn="tableColumn"
          :multi-selection="multiSelection"
          height="300px"
          :has-pagination="false"
        ></m-table>

        <MForm class="dispose-form" ref="form" :i18nPath="i18nPath" v-bind="form">
          <template #upload="{ model }">
            <UploadImage :urls="model" />
          </template>
        </MForm>
      </div>
    </el-scrollbar>
    <div class="operation">
      <el-button type="primary" @click="handler" :loading="loading">
        {{ $t('提交') }}
      </el-button>
      <el-button type="default" @click="cancel">{{ $t('取消') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapMutations } from 'vuex';
import Type from '@/store/mutation-type';

import MTable from '@/components/mTable/m-table';
import MForm from '@/components/form/index.vue';
import UploadImage from '@/components/upload/upload-image.vue';

import { disposeAlarmInfo } from '@/api/query';

import { formatTime } from '@/utils/date';
import { arrify, awaitTo } from '@/utils/utils';
import { isEmpty } from '@/utils/is';
import { getCaseList, getTitle, matchKey } from './utils';

export default {
  components: { MTable, MForm, UploadImage },
  data() {
    return {
      i18nPath: 'component.dispositionAlarm',
      title: '设备报警信息',
      visible: false,
      loading: false,
      disposeInfo: '',
      api: disposeAlarmInfo,
      form: {
        config: {
          labelWidth: 'auto',
          span: 24,
          options: [
            {
              type: 'input',
              prop: 'dispositionTime',
              disabled: true,
              showFormat: v => formatTime(v),
              label: '报警确认时间'
            },
            { type: 'input', prop: 'operator', placeholder: '请输入处理人', label: '报警处理人' },
            {
              span: 24,
              type: 'custom',
              slot: 'upload',
              prop: 'peoplePictures',
              label: '人员信息'
            },
            {
              span: 24,
              type: 'custom',
              slot: 'upload',
              prop: 'objectPictures',
              label: '实物照片'
            },
            {
              span: 24,
              type: 'custom',
              slot: 'upload',
              prop: 'devicePictures',
              label: '手持设备'
            },
            {
              type: 'radioGroup',
              prop: 'alarmType',
              dataKey: 'alarmTypeOptions',
              label: '报警种类'
            },
            {
              prop: 'dispositionSituation',
              label: '处理情况',
              children: [
                { type: 'checkboxGroup', dataKey: 'caseList', prop: 'dispositionSituation' },
                { type: 'input', attrs: { type: 'textarea' }, prop: 'dispositionInfo' }
              ]
            }
          ]
        },
        model: {
          dispositionTime: Date.now(),
          operator: '',
          alarmType: 'normalAlarm',
          dispositionInfo: '',
          dispositionSituation: [],
          peoplePictures: [],
          objectPictures: [],
          devicePictures: []
        },
        dataSource: {
          caseList: [],
          upload: {},
          alarmTypeOptions: [
            { label: '正常报警', value: 'normalAlarm' },
            { label: '演练报警', value: 'drillAlarm' },
            { label: '测试报警', value: 'testAlarm' }
          ]
        },
        rules: {
          operator: [
            {
              required: true,
              validator: (_rule, value, callback) => {
                const msg = this.$t('请填写处理人员');

                if (isEmpty(value)) {
                  callback(new Error(msg));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            }
          ],
          dispositionSituation: [
            {
              required: true,
              message: '请选择处理情况',
              validator: (_rule, value, callback) => {
                const msg = this.$t('请选择处理情况');

                if (isEmpty(value)) {
                  callback(new Error(msg));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            }
          ]
        }
      },
      multiSelection: [],
      tableData: [],
      tableColumn: [
        { label: '设备号', prop: 'sn' },
        { label: '设备名称', prop: 'deviceName' },
        { label: '设备类型', prop: 'deviceTypeName' },
        {
          label: '开始时间',
          prop: 'beginTime',
          temp: scope => {
            return `<span>${formatTime(scope.row.beginTime)}</span>`;
          }
        },
        {
          label: '结束时间',
          prop: 'endTime',
          temp: scope => {
            return `<span>${formatTime(scope.row.endTime)}</span>`;
          }
        },
        { label: '类型', prop: 'typeName' },
        { label: '报警内容', prop: 'message' }
      ]
    };
  },
  methods: {
    ...mapMutations('mqtt', {
      removeAlarmByIds: Type.REMOVE_ALARM_BY_IDS
    }),
    show() {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.form?.clearValidate();
      });
    },
    setFormData(data) {
      Object.assign(this.form.model, {
        dispositionTime: Date.now(),
        operator: data.operator,
        alarmType: data.alarmType,
        dispositionInfo: data.dispositionInfo,
        dispositionSituation: data.dispositionSituation.split(','),
        peoplePictures: data.peoplePictures.split(',').filter(Boolean),
        objectPictures: data.objectPictures.split(',').filter(Boolean),
        devicePictures: data.devicePictures.split(',').filter(Boolean)
      });
    },
    hide() {
      this.tableData = [];
      this.multiSelection = [];

      this.$refs.form?.resetFields();
      // Object.assign(this.form.model, {
      //   dispositionTime: Date.now(),
      //   operator: '',
      //   dispositionInfo: '',
      //   dispositionSituation: [],
      //   peoplePictures: [],
      //   devicePictures: [],
      //   objectPictures: []
      // });
      this.loading = false;
      this.visible = false;
    },
    setTableData(data) {
      const list = arrify(data);
      this.tableData = list;

      this.form.dataSource.caseList.splice(
        0,
        Infinity,
        ...getCaseList(matchKey(list[0].deviceType))
      );

      this.title = getTitle(list[0].deviceType);

      this.disposeInfo = data.dispositionInfo || '';
    },
    emitSuccessCallback() {
      this.$emit('success');
    },
    async handler() {
      if (this.loading) return;
      this.loading = true;
      const [, res] = await awaitTo(this.$refs.form.validate());

      if (!res) return (this.loading = false);

      const ids = this.multiSelection.map(e => e.id);

      const temp = this.multiSelection.find(e => !isEmpty(e.alarmGroupId)) || {};
      const alarmGroupId = temp.alarmGroupId || this.multiSelection[0].id;
      const sn = this.multiSelection[0].sn;

      if (isEmpty(ids)) return this.$message.warning(this.$t('请选择处置数据'));

      const {
        dispositionTime,
        operator,
        alarmType,
        dispositionInfo,
        dispositionSituation,
        peoplePictures,
        objectPictures,
        devicePictures
      } = this.form.model;
      const [err] = await awaitTo(
        this.api({
          sn,
          ids,
          alarmType,
          alarmGroupId,
          dispositionInfo,
          dispositionTime,
          operator,
          dispositionSituation: dispositionSituation.join(','),
          peoplePictures: peoplePictures.join(','),
          objectPictures: objectPictures.join(','),
          devicePictures: devicePictures.join(',')
        })
      );
      if (!err) {
        this.$message.success(this.$t('已处理'));
        this.removeAlarmByIds(ids);
        this.emitSuccessCallback();
        this.hide();
      } else {
        this.$message.warning(this.$t('处理失败'));
        this.loading = false;
      }
    },
    cancel() {
      this.hide();
    }
  },
  watch: {
    visible(n) {
      if (!n) return;
      this.$nextTick(() => {
        this.$refs.table.selectAll();
      });
    }
  }
};
</script>

<style lang="scss">
.disposition-alarm-multi {
  min-width: 800px;
  .operation {
    margin-top: 15px;
    display: flex;
    justify-content: flex-end;
  }
  .dispose-form {
    margin-top: 40px;
  }

  .el-form-item__label {
    &::after {
      content: '：';
    }
  }
}
</style>
